export enum PAGE_CONTAINER_WIDTH {
  NORMAL = "608px",
  MAX = "1024px",
}
